<template>
<div class="ui middle aligned center aligned grid">
  <div class="login">

      <h2 class="ui header">
        <div class="content">
          <img class="name" src="../assets/name.png">
        </div>
    </h2>

    <div class="row" style='text-align:left!important; font-size:15px;'>
      Por seguridad te pedimos que cambies la contraseña por una que contenga al menos 8 caracteres, mayúsculas, minúsculas y números.<br>
    </div>

    <div :class="classText" v-if="error">{{ errorText }}</div>

    <div class="ui stacked secondary segment">
      <form class="ui large form" @submit.prevent="changePassLogin">
          <div class="field">
            <div class="ui left icon input">
              <i class="lock icon"></i>
              <input type="password" name="password" v-model="password" placeholder="Password" pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])\S{8,}$" required>
            </div>
          </div>
          <div class="field">
            <div class="ui left icon input">
              <i class="lock icon"></i>
              <input type="password" name="repassword" v-model="repassword" placeholder="Re-Password" pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])\S{8,}$" required>
            </div>
          </div>
          <button class="ui fluid large teal button hapiick" type="submit">Guardar</button>
      </form>
    </div>
  </div>
</div>
</template>
<script>
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'ChangePass',
  data() {
    return {
      errorText: null,
      error: false,
      repassword: null,
      password: null,
      classText: null,
    }
  },
  created() {
  },
  methods: {
    changePassLogin() {
      if (this.password === this.repassword) {
        hapiickApi().post('/v1/login/change-pass', {
          admin_id: JSON.parse(localStorage.admin).id,
          password: this.password
        })
        .then(request => {
          this.changePassSuccessful(request.data)
          }
        )
        .catch(e => console.log(e))
      } else {
        this.error = true
        this.errorText = 'No coinciden las contraseñas.'
        this.classText = 'ui error message'
      }
    },
    changePassSuccessful(req) {
      if(req.status === 'OK') {
        let aux = JSON.parse(localStorage.getItem('admin'));
        aux.change_pass = false;
        localStorage.setItem('admin', JSON.stringify(aux));
        this.$router.replace(this.$route.query.redirect || '/dashboard')
      } else {
        this.error = true
        this.errorText = req.message
        this.classText = 'ui error message'
      }
    },
    setStyle(theme) {
      let color = (theme.primary_color) ? theme.primary_color : this.$primary_color_default;
      // this.$store.commit('set_primary_color', color)
      //document.documentElement.style.setProperty('--var-color', color)
    } 
  }
}
</script>
<style scoped>
a {
  color: darkslategrey;
}

.hapiick {
  color: black !important;
  background-color: #00f9a9 !important;
}

.footer {
  margin-top: 20px;
}

.footerText {
  font-size: 12px;
  font-weight: 300;
  color: black;
}

.name {
  width: 200px;
}

.login {
  text-align: center;
  margin-top: 25vh;
  width: 450px;
}

@media only screen and (max-width: 600px) {
  .login {
    text-align: center;
    margin-top: 25vh;
    width: 300px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ChangePass.vue